<template>
    <div class="order-wrapper" v-loading="loading" element-loading-text="拼命加载中">
        <div class="section-wrapper">
            <order_head :order="orderData" :check_type="check_type"></order_head>
            <el-tabs v-if="revise_order.type!=params.TYPE_TRY_OUT" type="border-card" class="order-detail-section mg20"
                     v-model="activeTab">
                <el-tab-pane label="财务信息"
                             v-if="$route.query['flow_type']==params.FINANCE_LINE"
                             name="2">
                    <order_line :order.sync="revise_order" :type="orderData.type" :tab="params.FINANCE_LINE"></order_line>
                </el-tab-pane>
                <el-tab-pane label="合同附件"
                             v-if="$route.query['flow_type']==params.CONTRACT_LINE"
                             name="3">
                    <order_line :order.sync="revise_order" :type="orderData.type" :tab="params.CONTRACT_LINE"></order_line>
                </el-tab-pane>
            </el-tabs>
            <order_reason :reason="revise_order.reason"></order_reason>
            <order_edit_attachment 
                :order="revise_order.content" 
                :before-order="revise_order.before_content"
                :is-revise-audit="true">
            </order_edit_attachment>
            <!--合同附件-->
            <order_origin_contract v-if="activeTab == params.CONTRACT_LINE" :order.sync="revise_order.before_content"></order_origin_contract>
            <div v-if="activeTab == params.CONTRACT_LINE">
                <div class="order-detail-section mg20">
                    <h3 style="color: red">修改信息如下：</h3>
                    <order_contract :order.sync="revise_order"></order_contract>
                </div>
                <div v-if="orderData.finance">
                    <order_contract_time :order.sync="orderData"></order_contract_time>
                    <order_performance :order.sync="orderData"></order_performance>
                    <order_customer_info :order.sync="orderData"></order_customer_info>
                    <order_scale :order.sync="orderData"></order_scale>
                    <order_plan_pay :order.sync="orderData"></order_plan_pay>
                    <div class="order-detail-section mg20"
                         v-if="orderData.finance && orderData.finance.express && orderData.finance.invoice && orderData.type != params.TYPE_TRY_OUT">
                        <h3>其他信息</h3>
                        <div class="order-userInfo">
                            <order_invoice :order.sync="orderData"></order_invoice>
                            <order_address :order.sync="orderData"></order_address>
                            <order_logistic :order.sync="orderData"></order_logistic>
                            <order_finance_other :order.sync="orderData"></order_finance_other>
                        </div>
                    </div>
                </div>


            </div>
            <!--产品信息-->
            <div class="order-detail-section mg20" v-if="revise_order.product_name">
                <h3 style="color: red" >修改【{{revise_order.product_name}}】信息如下：</h3>
                <order_product v-if="revise_order" :order="revise_order"></order_product>
            </div>
            <!--财务信息-->
            <div class="order-detail-section mg20" v-if="$route.query['flow_type']==params.FINANCE_LINE">
                <h3 style="color: red">修改信息如下：</h3>
                <product :order.sync="revise_order" :old-order="orderData"></product>
                <finance_contract  :order.sync="revise_order" :old-order="orderData"></finance_contract>
                <performance  :order.sync="revise_order" :old-order="orderData"></performance>
                <scale  :order.sync="revise_order" :old-order="orderData"></scale>
                <repay_plan  :order.sync="revise_order" :old-order="orderData"></repay_plan>
                <invoice  :order.sync="revise_order" :old-order="orderData"></invoice>
                <express  :order.sync="revise_order" :old-order="orderData"></express>
            </div>
        </div>
    </div>
</template>
<script>
    import OrderService from "~/services/order";
    import {OrderMixin} from "~/services/OrderMixin";
    import Params from "~/config/params";
    import Order_progress from "~/views/order/partial/order_progress.vue";
    import Order_product from "~/views/order/partial/order_product.vue";
    import order_contract from "~/views/order/partial/order_contract.vue";
    import finance_contract from "~/views/order/finance/finance_contract.vue";
    import invoice from "~/views/order/finance/invoice.vue";
    import performance from "~/views/order/finance/performance.vue";
    import express from "~/views/order/finance/express.vue";
    import product from "~/views/order/finance/product.vue";
    import repay_plan from "~/views/order/finance/repay_plan.vue";
    import order_invoice from "~/views/order/partial/order_invoice.vue";
    import order_address from "~/views/order/partial/order_address.vue";
    import order_logistic from "~/views/order/partial/order_logistic.vue";
    import order_plan_pay from "~/views/order/partial/order_plan_pay.vue";
    import order_customer_info from "~/views/order/partial/order_customer_info.vue";
    import order_performance from "~/views/order/partial/order_performance.vue";
    import order_line from "~/views/order/partial/order_line.vue";
    import order_finance_other from "~/views/order/partial/order_finance_other.vue";
    import order_reason from "~/views/order/partial/order_reason.vue";
    import order_edit_attachment from "~/views/order/partial/order_edit_attachment.vue";
    import order_origin_contract from "~/views/order/partial/order_origin_contract.vue";
    import order_contract_time from "~/views/order/partial/order_contract_time.vue";
    import order_scale from "~/views/order/partial/order_scale.vue";
    import scale from "~/views/order/finance/scale.vue";

    export default {
        mixins: [OrderMixin],
        data() {
            return {
                revise_product:false,
                revise_finance:false,
                revise_contract:false,
                revise_order: '',
                revise_id: this.$route.query['revise_id'],//修订id
            };
        },
        components: {
            Order_product,
            Order_progress,
            order_contract,
            order_invoice,
            order_address,
            order_logistic,
            order_plan_pay,
            order_customer_info,
            order_performance,
            order_line,
            order_finance_other,
            order_reason,
            order_edit_attachment,
            order_origin_contract,
            finance_contract,
            performance,
            invoice,
            express,
            repay_plan,
            product,
            order_contract_time,
            order_scale,
            scale
        },
        methods: {
            getReviseContent() {
                OrderService.getReviseContent(this.revise_id).then(res => {
                    if (res.code == 0) {
                        if (res.data) {
                            if (res.data.order_block == Params.PRODUCT_LINE) this.revise_order = res.data;
                            if (res.data.order_block == Params.FINANCE_LINE) {
                                let user = res.data.content.cooperator ? res.data.content.cooperator : res.data.content.user;
                                // user.unshift({
                                //     name: res.data.content.sale_name,
                                //     user_id: res.data.content.sale,
                                //     pfm_amount: res.data.content.performance_amount,
                                //     is_cooperator: 0
                                // })
                                this.revise_order = Object.assign({}, res.data, {
                                    finance: res.data.content,
                                    user: user,
                                    // 保持原始的 content 和 before_content 用于附件显示
                                    content: res.data.content,
                                    before_content: res.data.before_content
                                });
                            }
                            if (res.data.order_block == Params.CONTRACT_LINE){
                                this.revise_order = Object.assign({}, res.data, {
                                    contracts: res.data.content.file_list,
                                    contract_number: res.data.content.contract_number,
                                });
                            }
                            this.loading = false;
                        }
                    }
                })
            },
        },
        mounted() {
            this.params = Params;
            this.$nextTick(function () {
                this.getOrder(this.id);
                this.getReviseContent(this.revise_id);
            });
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/approve/reviseOrder.vue